import React, { useState } from 'react';
import { Form, Input, Button, Card, message, Modal } from 'antd';
import { UserOutlined, LockOutlined, MailOutlined } from '@ant-design/icons';
import API_ENDPOINTS from '../config/api';
import './Login.css';

const Login = ({ onLogin }) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [forgotPasswordForm] = Form.useForm();

  const onFinish = async (values) => {
    try {
      const loginUrl = `${API_ENDPOINTS.USERS}/login`;
      const response = await fetch(loginUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          username: values.username,
          password: values.password,
        }),
      });

      const data = await response.json();

      if (response.ok) {
        message.success('Login successful!');
        onLogin(data.token);
      } else {
        message.error(data.message || 'Login failed');
      }
    } catch (error) {
      console.error('Login error:', error);
      message.error('An error occurred during login');
    }
  };

  const handleForgotPassword = async (values) => {
    try {
      const forgotPasswordUrl = `${API_ENDPOINTS.USERS}/forgot-password`;
      const response = await fetch(forgotPasswordUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email: values.email,
        }),
      });

      const data = await response.json();

      if (response.ok) {
        message.success('Password reset instructions have been sent to your email');
        setIsModalVisible(false);
        forgotPasswordForm.resetFields();
      } else {
        message.error(data.message || 'Failed to process forgot password request');
      }
    } catch (error) {
      console.error('Forgot password error:', error);
      message.error('An error occurred while processing your request');
    }
  };

  return (
    <div className="login-container">
      <Card title="Admin Panel Login" className="login-card">
        <Form
          name="login"
          initialValues={{ remember: true }}
          onFinish={onFinish}
        >
          <Form.Item
            name="username"
            rules={[{ required: true, message: 'Please input your Username!' }]}
          >
            <Input prefix={<UserOutlined />} placeholder="Username" />
          </Form.Item>
          <Form.Item
            name="password"
            rules={[{ required: true, message: 'Please input your Password!' }]}
          >
            <Input
              prefix={<LockOutlined />}
              type="password"
              placeholder="Password"
            />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" className="login-button">
              Log in
            </Button>
            <Button type="link" onClick={() => setIsModalVisible(true)}>
              Forgot Password?
            </Button>
          </Form.Item>
        </Form>
      </Card>

      <Modal
        title="Forgot Password"
        open={isModalVisible}
        onCancel={() => {
          setIsModalVisible(false);
          forgotPasswordForm.resetFields();
        }}
        footer={null}
      >
        <Form
          form={forgotPasswordForm}
          name="forgotPassword"
          onFinish={handleForgotPassword}
        >
          <Form.Item
            name="email"
            rules={[
              { required: true, message: 'Please input your email!' },
              { type: 'email', message: 'Please enter a valid email!' }
            ]}
          >
            <Input prefix={<MailOutlined />} placeholder="Registered Email" />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" block>
              Submit
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default Login; 